/**
 * Batch packing slips (§12.3, Task 5) — every member order's A4 packing slip in
 * one print run (page-break between slips), so a batch's slips are generated
 * together. Reuses <PackingSlipDoc/>.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, type PackingSlipData } from "../../lib/api.js";
import { PrintFrame } from "./PrintFrame.js";
import { PackingSlipDoc } from "./PackingSlipDoc.js";

export function BatchPackingSlips() {
  const { batchId } = useParams();
  const [slips, setSlips] = useState<PackingSlipData[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    if (!batchId) return;
    api
      .getBatchPackingSlips(batchId)
      .then((r) => live && setSlips(r.slips))
      .catch(() => live && setError("Could not load the batch packing slips."));
    return () => {
      live = false;
    };
  }, [batchId]);

  return (
    <PrintFrame title={`Packing slips · ${batchId}${slips ? ` · ${slips.length}` : ""}`}>
      {error ? (
        <div className="doc">
          <p>{error}</p>
        </div>
      ) : !slips ? (
        <div className="doc">
          <p>Loading…</p>
        </div>
      ) : slips.length === 0 ? (
        <div className="doc">
          <p>No active orders in this batch.</p>
        </div>
      ) : (
        slips.map((data, i) => (
          <div key={data.order.id} className={i < slips.length - 1 ? "doc-page-break" : undefined}>
            <PackingSlipDoc data={data} />
          </div>
        ))
      )}
    </PrintFrame>
  );
}
